@if (authenticatedUser(); as authenticatedUser) {
  @let closedNav = closed();
  @let endedClose = ended();

  <div
    class="navigation flex flex-col h-screen fixed left-0 md:relative z-50 bg-menu-bg-1 dark:border-r dark:border-dark-300"
    [class.closed]="closedNav"
    [class.before:dark:bg-dark-900]="closedNav">
    <tess-navigation-top [branding]="branding" (toggled)="toggle()" [closed]="closedNav" />
    <div class="flex flex-col h-full overflow-clip min-h-0">
      <div class="z-10">
        <tess-navigation-account [user]="authenticatedUser.data" />
        <tess-navigation-actions />
      </div>

      <lib-tess-scroller>
        @for (item of items(); track item.Id) {
          <tess-navigation-item
            [item]="item"
            [subItems]="item.SubItems"
            [selected]="item.selected"
            [closed]="closedNav"
            [ended]="endedClose" />
        }
      </lib-tess-scroller>

      <div class="z-10 border-t border-light-700 dark:border-dark-300">
        <tess-theme-toggle />
        <tess-navigation-item [item]="documentation" [closed]="closedNav && endedClose" />
      </div>
    </div>
  </div>

  <div
    class="navigation__backdrop bg-dark-900/70 fixed z-40 inset-0 block transition md:hidden"
    tabindex="0"
    (keydown.enter)="toggle(true)"
    (click)="toggle(true)"></div>
}
